import React from 'react'

export default function AddressBlock({address, city, state_code, zip}) {
  return (
    <address className='not-italic'>
      {address ?
        <span>{address}, <br/></span> : null
      }
      {city}, {state_code} {zip}
    </address>
  )
}
